import { useMemo } from 'react';
import { FIELD_SHARE_IAR } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { useBooleanFlagValue } from '@rsos/utils/openFeature';

const useHasAccessToFieldShareIar = (): boolean => {
  const iarFlag = useBooleanFlagValue('field_share_iar', false);
  const hasIarCapability = useHasCapability(FIELD_SHARE_IAR);

  return useMemo(
    () => Boolean(iarFlag) && Boolean(hasIarCapability?.hasCapability),
    [iarFlag, hasIarCapability],
  );
};

export default useHasAccessToFieldShareIar;
